import React from 'react';

function toValidDate(value) {
    if (value == null || value === '') return null;

    // Timestamp numérique (secondes ou millisecondes)
    if (typeof value === 'number' && Number.isFinite(value)) {
        const ms = value < 1e12 ? value * 1000 : value;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const raw = String(value).trim();
    if (!raw || raw === '0000-00-00' || raw === '0000-00-00 00:00:00') {
        return null;
    }

    // "YYYY-MM-DD HH:mm:ss" → ISO-friendly pour Safari / certains navigateurs
    const normalized = raw.includes('T')
        ? raw
        : raw.replace(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})/, '$1T$2');

    const dateObj = new Date(normalized);
    if (Number.isNaN(dateObj.getTime())) {
        // Dernier essai : date seule
        const dateOnly = raw.slice(0, 10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
            const fallback = new Date(`${dateOnly}T00:00:00`);
            return Number.isNaN(fallback.getTime()) ? null : fallback;
        }
        return null;
    }

    return dateObj;
}

export default function FormattedDate({ date, customFormat }) {
    const dateObj = toValidDate(date);
    if (!dateObj) {
        return <span>—</span>;
    }

    let options;
    if (!customFormat) {
        options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };
    } else {
        options = {};
        if (customFormat.includes('day')) options.day = '2-digit';
        if (customFormat.includes('month')) options.month = 'long';
        if (customFormat.includes('year')) options.year = 'numeric';
        if (customFormat.includes('hour')) options.hour = '2-digit';
        if (customFormat.includes('minute')) options.minute = '2-digit';
    }

    try {
        const formattedDate = new Intl.DateTimeFormat('fr-FR', options).format(dateObj);
        return <span>{formattedDate.replace(',', ' .')}</span>;
    } catch {
        return <span>—</span>;
    }
}
